<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت نیاز ها - ثبت پیگیری های استعلام</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">لیست استعلام</h5>
                                <h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-lightt"
                                            @click="onArchiveClicked()">
                                        <i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>
                                        <i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>
                                    </button>
                                </div>


                            </div>
                            <div class="col-12 input-group round mb-3" v-if="!showArchive">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام سازمان/مشتری را وارد کنید">
                            </div>
                            <!--///////// FILTERS  /////////////////-->


                            <!--///////// FILTERS  /////////////////-->


                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="inquirisList.length===0">
                                        <p class="text-center mt-3">هیچ نیاز/استعلامی ثبت نشده است</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                                <tr>
                                                    <th>شماره نیاز</th>
                                                    <th>تاریخ نیاز</th>
                                                    <th>نام مشتری</th>
                                                    <th>وضعیت استعلام</th>
                                                    <th>تاریخ اتمام</th>
                                                    <th>ساعت اتمام</th>

                                                    <th class="text-center">عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="it in inquirisList" v-if="inquirisList.length>0">
                                                    <td class="text-nowrap">{{it.inquirynumber}}</td>
                                                    <td class="text-nowrap">{{showDateDayWork(it.startDate)}}</td>
                                                    <td class="text-wrap">{{it.customerFullName}}</td>
                                                    <td class="text-nowrap">{{showstatus(it.inquiryStatus)}}</td>
                                                    <td class="text-nowrap">{{showDateDayWork(it.expiryDate)}}</td>
                                                    <td class="text-nowrap">{{(showExpiryHour(it.expiryHour))}}</td>
                                                    <td class="text-center text-nowrap"><i
                                                            class="fa fa-pencil-square-o px-3 clickable"
                                                            style="font-size: larger"
                                                            @click="recordInquiriItem(it)"
                                                            title="ویرایش آیتم"></i>

                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
        <modal show="false" ref="insertModal" v-if="showinquiry">
            <div class="row p-3">
                <div class="col-12 text-center">
                    <h3> ثبت پیگیری های استعلام </h3>
                    <div class="row p-1">
                        <h4>مشخصات استعلام</h4>
                    </div>
                </div>

                <!--<hr class="w-100"/>-->
                <!--<h5 class="col-12 text-center"> نام سازمان/مشتری انتخاب شده</h5>-->
                <div class="row w-100">
                    <div class="row mt-0">
                        <div class="col-lg-3 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">شماره نیاز</span>
                                </div>
                                <input class="form-control" readonly="true" v-model="inquiriModel.inquirynumber">
                            </div>
                        </div>

                        <div class="col-lg-3 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ نیاز</span>
                                </div>
                                <input type="text" class="form-control" readonly="true" v-model="this.inquirydate">
                            </div>
                        </div>


                        <!--///////////////////////////////////////////-->
                        <!--////////////&lt;!&ndash;مشخصات استعلام &ndash;&gt;-->
                        <!--/////////////////////////////////////////////-->
                        <div class="col-lg-6 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">نام مشتری/سازمان</span>
                                </div>
                                <input type="text" class="form-control" readonly="true"
                                       v-model="inquiriModel.customerFullName">
                            </div>
                        </div>

                        <div class="col-lg-3 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ شروع</span>
                                </div>
                                <input type="text" class="form-control" readonly="true"
                                       v-model="this.inquiryStartdate">
                            </div>
                        </div>

                        <!--<div class="col-lg-2 mb-1">-->
                            <!--<div class="input-group round">-->
                                <!--<div class="input-group-prepend">-->
                                    <!--<span class="input-group-text">ساعت شروع</span>-->
                                <!--</div>-->
                                <!--<input type="number" class="form-control" readonly="true"-->
                                       <!--v-model="inquiriModel.startHour">-->
                            <!--</div>-->
                        <!--</div>-->

                        <div class="col-lg-3 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تاریخ اتمام</span>
                                </div>
                                <input type="text" class="form-control" readonly="true"
                                       v-model="this.inquiryEnddate">
                            </div>
                        </div>

                        <div class="col-lg-2 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ساعت اتمام</span>
                                </div>
                                <input type="number" class="form-control" readonly="true"
                                       v-model="inquiriModel.expiryHour">
                            </div>
                        </div>

                        <div class="col-lg-2 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مدت تسویه</span>
                                </div>
                                <input type="number" class="form-control" readonly="true"
                                       v-model="inquiriModel.settlementPeriod">
                            </div>
                        </div>

                        <div class="col-lg-2 mb-1">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">وزن تقریبی</span>
                                </div>
                                <input type="number" class="form-control" readonly="true"
                                       v-model="inquiriModel.productWeight">
                            </div>
                        </div>

                        <!--///////////////////////////////////////////-->
                        <!--////////////&lt;!&ndash;مشخصات استعلام &ndash;&gt;-->
                        <!--/////////////////////////////////////////////-->
                    </div>
                </div>
                <hr class="w-100"/>
                <div class="row w-100 p-0">
                    <!--<div class="card-header admin-header w-100">-->
                        <!--<h5 class="col-12 text-center">تامین کنندن</h5>-->
                    <!--</div>-->
                    <div class="col-12 overflow-auto" style="max-height: 12rem;">
                        <table class="table table-hover table-striped mb-3">
                            <thead>
                                <tr>
                                    <th class="text-center">کد تامین کننده</th>
                                    <th class="text-center">نام تامین کننده</th>
                                    <th class="text-center">شماره همراه</th>
                                    <th class="text-center">نحوه حمل</th>
                                    <th class="text-center">نوع فاکتور</th>
                                    <th class="text-center">مدت تسویه</th>

                                    <th class="text-center">قیمت پیشنهادی</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in supplierinquiry" v-if="item.inquiryId>0">
                                    <td class="text-center">{{item.customerCode}}</td>
                                    <td class="text-nowrap">{{item.customerFullName}}</td>
                                    <td class="text-nowrap">{{item.mobile}}</td>
                                    <td class="text-nowrap">{{item.shippingMethodView}}</td>
                                    <td class="text-nowrap">{{item.invoiceTypeView}}</td>
                                    <td class="text-nowrap">{{item.settlementPeriodWithSupplier}}</td>
                                    <td class="text-nowrap">
                                        <span v-if="isNaN(item.totalPrice)"
                                                 class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{(item.totalPrice).toLocaleString()}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <h5 class="col-12 text-center"> کالاهای استعلام</h5>
                <div class="col-12 overflow-auto" style="max-height: 12rem;">
                    <table class="table table-hover table-striped mb-3">
                        <thead>

                            <tr>
                                <th class="text-center text-nowrap">نام کالا</th>
                                <th class="text-center text-nowrap">واحد</th>
                                <th class="text-center text-nowrap">تعداد/وزن</th>
                                <th class="text-center text-nowrap">قیمت خرید</th>
                                <th class="text-center text-nowrap">مبلغ کل خرید</th>
                                <th class="text-center text-nowrap">درصد افزایش</th>
                                <th class="text-center text-nowrap">قیمت فروش</th>
                                <th class="text-center text-nowrap">مبلغ کل فروش</th>
                                <th class="text-center text-nowrap">ارزش افزوده%</th>
                                <th class="text-center text-nowrap">مبلغ ارزش افزوده</th>
                                <th class="text-center text-nowrap">جمع نهایی</th>
                            </tr>

                        </thead>
                        <tbody>
                            <tr v-for="item in productPriceInquiry" v-if="item.productCount>0">

                                <td class="text-center text-nowrap">{{item.productName}}</td>
                                <td class="text-center text-nowrap">{{item.unitName}}</td>
                                <td class="text-center text-nowrap">{{item.productCount}}</td>
                                <td class="text-center text-nowrap">
                                    <span v-if="isNaN(item.buyPrice)"
                                              class="text-warning">0</span>
                                    <span v-else>{{(item.buyPrice).toLocaleString()}}</span>
                                </td>

                                <td class="text-center text-nowrap">
                                        <span v-if="isNaN(item.buyTotalNetPrice)"
                                              class="text-warning">0</span>
                                    <span v-else>{{(item.buyTotalNetPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center pb-0">
                                    <span v-if="isNaN(item.percentageIncrease)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(item.percentageIncrease).toLocaleString()}}</span>
                                </td>
                                <td class="text-center pb-0">
                                    <span v-if="isNaN(item.sellPrice)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(item.sellPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center pb-0">
                                    <span v-if="isNaN(item.sellTotalPrice)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(item.sellTotalPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center pb-0">
                                    <span v-if="isNaN(item.sellVat)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(item.sellVat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center pb-0">
                                    <span v-if="isNaN(item.sellTotalVat)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(item.sellTotalVat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center pb-0">
                                    <span v-if="isNaN(item.sellTotalPriceVat)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(item.sellTotalPriceVat).toLocaleString()}}</span>
                                </td>
                           </tr>
                           <tr>
                                <td colspan="6"></td>
                           </tr>
                           <tr class="bg-total-discount mt-3">
                                <td colspan="0"></td>
                                <td class="text-right">
                                    <span>جمع کل:</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>تعداد کل: </span>-->
                                    <span v-if="isNaN(tproductcount)" class="text-warning">0</span>
                                    <span v-else>{{this.tproductcount}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>قیمت : </span>-->
                                    <span v-if="isNaN(tbuyprice)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tbuyprice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع قیمت : </span>-->
                                    <span v-if="isNaN(tbuyTotalNetPrice)"
                                          class="text-warning">0</span>
                                    <span v-else>{{(tbuyTotalNetPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع تخفیف : </span>-->
                                    <span v-if="isNaN((tpercentageIncrease))"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tpercentageIncrease)}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع بعد از تخفیف : </span>-->
                                    <span v-if="isNaN((tsellPrice))"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tsellPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>مالیات بر ارزش افزوده : </span>-->
                                    <span v-if="isNaN((tsellTotalPrice))"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tsellTotalPrice).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>مالیات بر ارزش افزوده : </span>-->
                                    <span v-if="isNaN((tsellVat))"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tsellVat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع کل استعلام : </span>-->
                                    <span v-if="isNaN((tsellTotalVat))"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tsellTotalVat).toLocaleString()}}</span>
                                </td>
                                <td class="text-center">
                                    <!--<span>جمع کل استعلام : </span>-->
                                    <span v-if="isNaN((tsellTotalPriceVat))"
                                          class="text-warning">0</span>
                                    <span v-else>{{(this.tsellTotalPriceVat).toLocaleString()}}</span>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <div class="col-lg-12 mb-2">
                    <div class="row mt-0">
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جمع مبلغ فروش</span>
                                </div>
                                <span type="number" class="form-control"> {{tsellTotalPrice.toLocaleString()}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">هزینه حمل تقریبی</span>
                                </div>
                                <span type="number" class="form-control">{{inquiriModel.shippingCostEstimate.toLocaleString()}}</span>
                            </div>
                        </div>
                        <div class="col-lg-4 mb-2">
                            <div class="input-group round">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جمع کل استعلام</span>
                                </div>
                                <span type="number" class="form-control" >{{inquiriModel.suggestedPrices.toLocaleString()}}</span>

                            </div>
                        </div>
                    </div>
                </div>





                <div class="col-lg-12 mb-2">

                    <div class="col-lg-12  text-center">
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="sendInvoice">ارسال فاکتور
                        </button>
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="sendProducts" >ارسال بار
                        </button>
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="registerInTejarat">ثبت در جامع تجارت
                        </button>
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="receiveInvoice">دریافت فاکتور خرید
                        </button>
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="cancelInquiryFollowUp">پیگیری وصول مطالبات
                        </button>
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="cancelInquiryFollowUp">وصول مطالبات
                        </button>
                        <button class="btn btn-outline-success btn-round clickable mt-3 mx-2"
                                @click="cancelInquiryFollowUp">اتمام پروسه
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-2"
                                @click="cancelInquiryFollowUp">بازگشت
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- ------------------------ ارسال فاکتور فروش --------------------------- -->
        <modal show="false" ref="insertModal" v-if="showsendInvoice">
            <div class="row p-3">
                <div class="col-12 text-center">
                    <h3> ثبت پیگیری های ارسال فاکتور فروش به مشتری </h3>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تاریخ ارسال/پیگیری</span>
                        </div>
                        <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateSendInvoiceDatePicked"
                                     :auto-submit="true"
                                     ref="sendInvoicedate" style="flex: 1">
                            <slot>
                                <input v-model="sendInvoicedate"
                                       class="form-control date-input flex-grow-1" readonly="true"
                                       @click="toggleCreateSendInvoiceDatePicker">
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                     <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">نحوه ارسال</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="enShippingSendInvoice"
                                   :mode="'create'"
                                   :selected-val="filterShippingSendInvoice"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterShippingSendInvoiceChange"></vs-select>
                     </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">بارکد پستی</span>
                        </div>
                        <input class="form-control" v-model="sendInvoiceModel.postalbarcode">
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">نام گیرنده</span>
                        </div>
                        <input class="form-control" v-model="sendInvoiceModel.receiverName">
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">فاکتور تحویل مشتری</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="done"
                                   :mode="'create'"
                                   :selected-val="filterdeliveryToCustomer"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterdeliveryToCustomerChange"></vs-select>
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">فاکتور تحویل امور مالی</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="done"
                                   :mode="'create'"
                                   :selected-val="filterdeliveryToFinance"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterdeliveryToFinanceChange"></vs-select>

                    </div>

                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">اتمام پروسه تحویل فاکتور</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="yesno"
                                   :mode="'create'"
                                   :selected-val="filterInvoiceDeliveryStatus"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterInvoiceDeliveryStatusChange"></vs-select>

                    </div>

                </div>

                <div class="col-lg-12 mb-2">

                    <div class="col-lg-12  text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updateSendInvoice" v-if="sendInvoiceMode==='edit'">ویرایش اطلاعات
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createSendInvoice" v-else>ثبت اطلاعات
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-2"
                                @click="cancelSendInvoice">بازگشت
                        </button>
                    </div>
                </div>
            </div>
        </modal>

        <!-- ------------------------ ارسال بار - کالاها --------------------------- -->
        <modal show="false" ref="insertModal" v-if="showsendProducts">
            <div class="row p-3">
                <div class="col-12 text-center">
                    <h3> ثبت پیگیری های ارسال کالا به مشتری </h3>
                </div>

                <div class="col-lg-3 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تاریخ ارسال/پیگیری</span>
                        </div>
                        <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateSendProductsDatePicked"
                                     :auto-submit="true"
                                     ref="sendProductsdate" style="flex: 1">
                            <slot>
                                <input v-model="sendProductsdate"
                                       class="form-control date-input flex-grow-1" readonly="true"
                                       @click="toggleCreateSendProductsDatePicker">
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">نحوه ارسال کالا</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="enShippingSendProduct"
                                   :mode="'create'"
                                   :selected-val="filterShippingSendProduct"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterShippingSendProductChange"></vs-select>
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">شماره بارنامه</span>
                        </div>
                        <input class="form-control" v-model="sendProductsModel.landingNumber">
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">نام راننده</span>
                        </div>
                        <input class="form-control" v-model="sendProductsModel.receiverProductsName">
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">کالاها تحویل مشتری</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="done"
                                   :mode="'create'"
                                   :selected-val="filterdeliveryProductToCustomer"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterdeliveryProductsToCustomerChange"></vs-select>
                    </div>
                </div>
                <div class="col-lg-3 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">اتمام پروسه تحویل بار</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="yesno"
                                   :mode="'create'"
                                   :selected-val="filterProductsDeliveryStatus"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterProductsDeliveryStatusChange"></vs-select>

                    </div>

                </div>

                <div class="col-lg-12 mb-2">

                    <div class="col-lg-12  text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updateSendProducts" v-if="sendProductsMode==='edit'">ویرایش اطلاعات
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createSendProducts" v-else>ثبت اطلاعات
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-2"
                                @click="cancelSendProducts">بازگشت
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <!-- ------------------------ ثبت در جامع تجارت --------------------------- -->
        <modal show="false" ref="insertModal" v-if="showRegisterInTejarat">
            <div class="row p-3">
                <div class="col-12 text-center">
                    <h3> ثبت پیگیری ثبت در سامانه جامع تجارت </h3>
                </div>

                <div class="col-lg-6 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تاریخ ارسال/پیگیری</span>
                        </div>
                        <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateRegisterInTejaratDatePicked"
                                     :auto-submit="true"
                                     ref="registerInTejaratDate" style="flex: 1">
                            <slot>
                                <input v-model="registerInTejaratDate"
                                       class="form-control date-input flex-grow-1" readonly="true"
                                       @click="toggleRegisterInTejaratDatePicker">
                            </slot>
                        </date-picker>
                    </div>
                </div>

                <div class="col-lg-6 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">اتمام پروسه ثبت در جامع تجارت</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="yesno"
                                   :mode="'create'"
                                   :selected-val="filterRegisterInTejaratStatus"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterRegisterInTejaratStatusChange"></vs-select>

                    </div>

                </div>

                <div class="col-lg-12 mb-2">

                    <div class="col-lg-12  text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updateRegisterInTejarat" v-if="registerInTejaratMode==='edit'">ویرایش اطلاعات
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createRegisterInTejarat" v-else>ثبت اطلاعات
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-2"
                                @click="cancelRegisterInTejarat">بازگشت
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <!-- ------------------------ دریافت فاکتور خرید --------------------------- -->
        <modal show="false" ref="insertModal" v-if="showReceiveInvoice">
            <div class="row p-3">
                <div class="col-12 text-center">
                    <h3> ثبت پیگیری های دریافت فاکتور خرید از تامین کننده</h3>
                </div>

                <div class="col-lg-6 mb-2">
                    <div class="input-group round">
                        <div class="input-group-prepend">
                            <span class="input-group-text">تاریخ دریافت/پیگیری</span>
                        </div>
                        <date-picker type="date" format="jYYYY/jMM/jDD" @input="onCreateReceiveInvoiceDatePicked"
                                     :auto-submit="true"
                                     ref="receiveInvoiceDate" style="flex: 1">
                            <slot>
                                <input v-model="receiveInvoiceDate"
                                       class="form-control date-input flex-grow-1" readonly="true"
                                       @click="toggleReceiveInvoiceDatePicker">
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="col-lg-6 mb-2">
                    <div class="input-group round">

                        <div class="input-group-prepend">
                            <span class="input-group-text">اتمام پروسه دریافت فاکتور</span>

                        </div>
                        <vs-select @onSearch="onDropDownFocused"
                                   @onSearchBlurred="onDropDownBlurred"
                                   ref="evidence"
                                   :data="yesno"
                                   :mode="'create'"
                                   :selected-val="filterReceiveInvoice"
                                   :header="{multiple: false, label: 'title'}"
                                   aria-placeholder=""
                                   @onChange="onfilterReceiveInvoiceStatusChange"></vs-select>

                    </div>

                </div>

                <div class="col-lg-12 mb-2">

                    <div class="col-lg-12  text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updateReceiveInvoice" v-if="receiveInvoiceMode==='edit'">ویرایش اطلاعات
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createReceiveInvoice" v-else>ثبت اطلاعات
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-2"
                                @click="cancelReceiveInvoice">بازگشت
                        </button>
                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "inquiryFollowUp",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isLoading: true,
                inquiriPriceMode: "",
                inquiriModel: {
                    userId: "",
                    createdate: "",
                    inquiriType: "",
                    inquirynumber: "",
                    registrationDate: "",
                    customerId: "",
                    family: "",
                    fullName: "",
                    mobile: "",
                    startDate: "",
                    startHour: "",
                    expiryDate: "",
                    expiryHour: "",
                    recordDate :"",
                    recordHour :"",
                    settlementPeriod: "",
                    employeeId: "",
                    guaranteeAmount: 0,
                    inquiryStatus: "",
                    suggestedPrices:0,
                    actualShippingCost:0,
                    shippingCostEstimate:0,
                    productWeight:0,
                    winnerAmount:0,

                },
                winnerAmountShow :"",
                inquirisList: [],
                supplierList: [],
                inquiryId: "",
                inquirydate: "",
                inquiryStartdate: "",
                inquiryEnddate: "",
                maxtime: 24,
                fromhour: 0,
                tohour: 0,
                eninquiritype: [],
                selectedinquiritype:"",
                inquiriType: "",
                fullName: "",

                products: [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],
                selectedproduct: {},
                selectedinquiryproduct: [],
                productsInquiry: [{
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                }],

                productModel: {
                    inquiryId: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    needSample: "",
                    samplevalue: "",
                    row: ""
                },

                productinquirisList: [],
                productName: "",
                productCode: "",
                unitId: "",
                unitName: "",
                selectedUnit: [],
                productCount: "",
                description: "",
                needSample: "",
                sampletitle: "",
                units: [],
                selectedUnits: "",
                selectedSample: [],
                samplevalue: "",
                ensamples: [],

                invoicevalue: "",
                eninvoiceType: [],
                sampleid: "",
                rows: 0,
                checksaveok: false,
                showinquiry: false,
                showsupplierinquiry: false,
                inquirystatuslist: [],
                inquirystatuslistWinLost:[],
                selectedinquiristatus:"",


                productInquiryModel: {
                    id:"",
                    inquiryId: "",
                    supplierInquiryId: "",
                    productId: "",
                    unitId: "",
                    row: 0,
                    productCount: "",
                    buyPrice: 0,
                    buyTotalNetPrice: 0,
                    percentageIncrease:"",
                    sellPrice: 0,
                    sellTotalPrice: 0,
                    sellDiscount: 0,
                    sellTotalNetPrice: 0,
                    sellVat: 0,
                    sellTotalVat: 0,
                    sellTotalPriceVat: 0,
                },
                productPriceInquiry: [{
                    id: "",
                    supplierInquiryId: "",
                    inquiryId: "",
                    needSample: "",
                    productId: "",
                    productName: "",
                    productCode: "",
                    unitId: "",
                    unitName: "",
                    productCount: "",
                    descriptionOnSite: "",
                    row: 0,
                    buyPrice: 0,
                    buyTotalPrice: 0,
                    buyDiscount: 0,
                    buyTotalNetPrice: 0,
                    buyVat: 0,
                    buyTotalVat: 0,
                    buyTotalPriceVat: 0,
                    buyVatshow: "",
                    buyPriceshow: "",
                    buyTotalPriceshow: "",
                    buyDiscountshow: "",
                    buyTotalNetPriceshow: "",
                    buyTotalVatshow: "",
                    buyTotalPriceVatshow: "",

                    percentageIncrease:"",
                    percentageIncreaseShow:"",
                    sellPrice: 0,
                    sellTotalPrice: 0,
                    sellDiscount: 0,
                    sellTotalNetPrice: 0,
                    sellVat: 0,
                    sellTotalVat: 0,
                    sellTotalPriceVat: 0,
                    sellVatshow: "",
                    sellPriceshow: "",
                    sellTotalPriceshow: "",
                    sellDiscountshow: "",
                    sellTotalNetPriceshow: "",
                    sellTotalVatshow: "",
                    sellTotalPriceVatshow: "",
                }],
                productPriceInquiryModel: {
                    supplierInquiryId: "",
                    inquiryId: "",
                    row: 0,
                    productId: "",
                    unitId: "",
                    productCount: "",
                    buyPrice: 0,
                    totalPrice: 0,
                    discount: 0,
                    totalNetPrice: 0,
                    vat: 0,
                    totalVat: 0,
                    totalPriceVat: 0,

                },
                supplierinquiryId: "",
                filtersupplier: "",
                suppliers: [],

                supplierStatuses:[
                    {
                        title : "برنده",
                        value : 1,
                    },
                    {
                        title :"بازنده",
                        value :2,
                    }
                ],
                filtersupplierStatuses :[],
                ///////////////////////////////////////////////////////////////
                ////////// new var                              ///////////////
                ///////////////////////////////////////////////////////////////

                tproductcount: 0,
                tbuyprice: 0,
                tbuyTotalNetPrice: 0,
                tdiscount: 0,
                ttotalNetPrice: 0,
                tvat: 0,
                ttotalVat: 0,
                ttotalPriceVat: 0,

                vatshow: 0,
                tbuyPrice: 0,
                tpercentageIncrease:0,
                tbuyTotalPrice: 0,
                tsellPrice: 0,
                tsellTotalPrice: 0,
                tsellTotalPriceshow: "",

                tsellDiscount: 0,
                tsellTotalNetPrice: 0,
                tsellVat: 0,
                tsellTotalVat: 0,
                tsellTotalPriceVat: 0,
                totalSuggestAmont :0,
                totalSuggestAmontshow :"",
                shippingCostEstimateshow:"",

                done :[{
                    title: "شد",
                    value: 1
                },
                    {
                    title : "نشد",
                    value : 2
                }],
                yesno :[{
                    title: "بله",
                    value: 1
                },
                    {
                        title : "خیر",
                        value : 2
                    }],
                maxvat: 20,

                supplierinquiry: [{
                    actionerId :0,
                    customerCode : '',
                    customerFullName: '',
                    customerId: '',
                    id: '',
                    inquiryId: '',
                    invoiceType: '',
                    invoiceTypeView: '',
                    maximumValidityDate: '',
                    mobile: '',
                    nationalCode: '',
                    otherExplanations: '',
                    proformaInvoiceStatus: '',
                    rank: '',
                    rankView: '',
                    row: '',
                    sampleProduct: '',
                    sampleShipmentCode: '',
                    settlementPeriodWithSupplier: '',
                    shippingMethod: '',
                    shippingMethodView: '',
                    status: '',
                    supplierInquiryDate: '',
                    supplierInquiryHour: '',
                    supplierInquiryId: '',
                    taxCode: '',
                    totalPrice: '',
                    userId: '',
                    userName: '',
                }],
                supplierinquiry2: [],
                supplierInquiryProducts: [],
                maximumValidityDate: "",
                sumproductcount: 0,
                sumbuyprice: 0,
                sumtotalprice: 0,
                sumdiscount: 0,
                sumtotalnetprice: 0,
                sumVat: 0,
                sumtotalvat: 0,
                sumtotalpricevat: 0,
                supplierInquiryDate: "",
                supplierInquiryList: {

                    id: "",
                    supplierInquiryId: "",
                    inquiryId: "",
                    row: "",
                    supplierInquiryDate: "",
                    supplierInquiryHour: "",
                    customerId: "",
                    customerCode: "",
                    customerFullName: "",
                    nationalCode: "",
                    mobile: "",
                    shippingMethod: "",
                    invoiceType: "",
                    totalPrice: "",
                    totalPriceshow: "",
                    maximumValidityDate: "",
                    settlementPeriodWithSupplier: "",
                    sampleProduct: "",
                    sampleShipmentCode: "",
                    actionerId: "",
                    otherExplanations: "",
                    proformaInvoiceStatus: "",
                    status: "",
                    rank:"",
                    rankView : "",

                },

                supplierInquiryModel: {
                    id :"",
                    inquiryId: "",
                    userId: "",
                    row: "",
                    supplierInquiryDate: "",
                    supplierInquiryHour: "",
                    customerId: "",
                    employeeId: "",
                    shippingMethod: "",
                    invoiceType: "",
                    totalPrice: "",
                    maximumValidityDate: "",
                    settlementPeriodWithSupplier: "",
                    sampleProduct: false,
                    sampleShipmentCode: "",
                    actionerId: "",
                    otherExplanations: "",
                    proformaInvoiceStatus: false,
                    status: "",
                    rank :0,
                },
                supplierInquiryUpdateModel: {
                    id :"",
                    inquiryId: "",
                    userId: "",
                    row: "",
                    supplierInquiryDate: "",
                    supplierInquiryHour: "",
                    customerId: "",
                    employeeId: "",
                    shippingMethod: "",
                    invoiceType: "",
                    totalPrice: "",
                    maximumValidityDate: "",
                    settlementPeriodWithSupplier: "",
                    sampleProduct: false,
                    sampleShipmentCode: "",
                    actionerId: "",
                    otherExplanations: "",
                    proformaInvoiceStatus: false,

                    status: "",
                    rank :0
                },
                causes: [],
                filtercauses :"",
                inquiricausesModel : {
                    id: 0,
                    inquiryId: 0,
                    causesId: 0,
                    percentage: "",
                    description: "",
                },
                inquiricausesList : [{
                    id: 0,
                    inquiryId: 0,
                    causesId: 0,
                    reason :"",
                    percentage: "",
                    description: "",
                }],
                inquiricausesMode : 'create',
                // /////////////////////////////////////////////////////////////
                ////////// old var                              ///////////////
                ///////////////////////////////////////////////////////////////


                recordDate: "",
                newendDate: "",
                recodHoure :"",

                search: "",




                showArchive: false,

                isSending: false,



                ////////////////////// End  Old var/////////////////////////////////
                ////////////////////// Daily Reports Parameter /////////////////////////////////
                dailyReportModel: {
                    id: 0,
                    description: "",
                    day : "",
                    fromTime : "",
                    toTime : "",
                    totalWork : "",
                    titleWorkId : "",
                    bossId :"",
                    bossApprovalDate : "",
                    managerId : "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                },
                dateObj :"",
                currentDate :"",
                hFrom :"",
                mFrom :"",
                hTo :"",
                mTo :"",
                totaltime:"",
                hourTotal:"",
                minuteTotal:"",
                displaytotalWork :"",
                dailyReportMode : "create" ,
                enShippingMethod: [],
                //////////////////////End  Daily Reports Parameter /////////////////////////////////
                ////////////////////// Send Invoice  /////////////////////////////////
                filterShippingSendInvoice: "",

                enShippingSendInvoice: [],
                filterdeliveryToCustomer : "",
                filterdeliveryToFinance : "",
                filterInvoiceDeliveryStatus : "",
                showsendInvoice:false,
                sendInvoicedate:"",
                sendInvoiceMode : "create",
                sendInvoiceModel :{
                    sendInvoicedate:"",
                    receiverName :"",
                    shippingSendInvoice :"",
                    postalbarcode:"",
                    deliveryToCustomer : "",
                    deliveryToFinance : "",
                    invoiceDeliveryStatus : "",
                },



                ////////////////////// end Send Invoice  /////////////////////////////////
                ////////////////////// Send Products  /////////////////////////////////
                filterProductsDeliveryStatus : "",
                filterdeliveryProductToCustomer : "",
                filterShippingSendProduct: "",
                enShippingSendProduct: [],
                sendProductsdate : "",
                showsendProducts:false,
                sendProductsDate:"",
                sendProductsMode : "create",
                sendProductsModel :{
                    sendProductsdate:"",
                    receiverProductsName :"",
                    shippingSendProducts :"",
                    landingNumber :"",
                    deliveryProductToCustomer :"",
                    productsDeliveryStatus :"",
                },


                ////////////////////// end Send Invoice  /////////////////////////////////
                ////////////////////// Register In Tejarat  /////////////////////////////////
                showRegisterInTejarat : false,
                filterRegisterInTejaratStatus : "",
                registerInTejaratDate : "",
                registerInTejaratMode : "create",

                registerInTejaratModel :{
                    registerInTejaratdate:"",
                    registerInTejaratStatus :""
                },


                ////////////////////// Register In Tejarat /////////////////////////////////
                ////////////////////// ReceiveInvoice  /////////////////////////////////
                showReceiveInvoice : false,
                filterReceiveInvoice : "",
                receiveInvoiceDate:"",
                receiveInvoiceMode : "create",
                filterReceiveInvoiceStatus : "",
                receiveInvoiceModel :{
                    receiveInvoiceDate:"",
                    receiveInvoiceStatus :""
                },


                ////////////////////// end Send Invoice  /////////////////////////////////

            }
        },
        mounted() {



            this.getCauses();
            this.getenSample();
            this.getEnInquiriType();
            this.getEnShippingSendInvoice();
            this.getEnShippingSendProduct();
            this.getEnInquiryStatus();
            this.getEnInquiryStatusWinLost();
            this.getEnInvoiceType();
            this.getInquirisList();
            this.getEnShippingMethod();



        },
        methods: {
            getEnShippingMethod() {
                new BaseService("enum", "/GetEnShippingMethod").getList().then(response => {
                    this.enShippingMethod = response.data;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            receiveInvoice(){
                this.showinquiry=false;
                this.showsendInvoice=false;
                this.showsendProducts=false;
                this.showRegisterInTejarat=false;
                this.showReceiveInvoice=true;

                this.receiveInvoiceDate="";
                this.receiveInvoiceMode = "create";

                this.receiveInvoiceModel ={
                    receiveInvoiceDate:"",
                    receiveInvoiceStatus :"",
                };
                this.filterReceiveInvoice = "";


                this.$refs.insertModal.showModal();

            },
            registerInTejarat(){
                this.showinquiry=false;
                this.showsendInvoice=false;
                this.showsendProducts=false;
                this.showRegisterInTejarat=true;

                this.registerInTejaratDate="";
                this.registerInTejaratMode = "create";

                this.registerInTejaratModel ={
                    registerInTejaratdate:"",
                    registerInTejaratStatus :"",
                };
                this.filterShippingSendProduct="";
                this.filterdeliveryToCustomer = "";
                this.filterdeliveryToFinance = "";
                this.filterInvoiceDeliveryStatus = "";

                this.$refs.insertModal.showModal();

            },
            sendProducts(){
                this.showinquiry=false;
                this.showsendInvoice=false;
                this.showsendProducts=true;

                this.sendProductsDate="";
                this.sendProductsMode = "create";

                this.sendProductsModel ={
                    sendProductsdate:"",
                    receiverProductsName :"",
                    shippingSendProducts :"",
                    landingNumber :"",
                    deliveryToCustomer :"",
                    productsDeliveryStatus :"",
                };
                this.filterShippingSendProduct="";
                this.filterdeliveryToCustomer = "";
                this.filterdeliveryToFinance = "";
                this.filterInvoiceDeliveryStatus = "";

                this.$refs.insertModal.showModal();

            },

            sendInvoice(){
                this.showinquiry=false;
                this.showsendInvoice=true;
                this.sendInvoicedate="";
                this.sendInvoiceMode = "create";

                this.sendInvoiceModel ={
                    sendInvoicedate:"",
                        receiverName :"",
                        shippingMethod :"",
                        postalbarcode:"",
                        deliveryToCustomer : "",
                        deliveryToFinance : "",
                        InvoiceDeliveryStatus : "",
                };
                this.filterShippingSendInvoice="";
                this.filterdeliveryToCustomer = "";
                this.filterdeliveryToFinance = "";
                this.filterInvoiceDeliveryStatus = "";

                this.$refs.insertModal.showModal();

            },
            getCauses() {
                new BaseService("causes", "/GetCauses").getList().then(response => {
                    this.causes = response.data;

                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getEnInquiryStatus() {
                new BaseService("enum", "/GetEnInquiriStatus").getList().then(response => {

                    this.inquirystatuslist = response.data;

                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },
            getEnInquiryStatusWinLost() {
                new BaseService("enum", "/GetEnInquiriStatus").getList().then(response => {

                    this.inquirystatuslistWinLost=[];
                    for(let resp of response.data)
                    {
                        if(resp.value>4)
                        {
                            this.inquirystatuslistWinLost.push(resp);
                        }
                    }

                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },


            setInquiryStatusName() {

                if (this.inquirisList && this.inquirystatuslist) {
                    for (let lis of this.inquirisList) {
                        for (let res of this.inquirystatuslist) {
                            if (parseInt(lis.inquiryStatus) === parseInt(res.value)) {
                                lis.inquiryStatusName = res.title;
                                break;
                            }
                        }

                    }
                }
            },
            showstatus(val) {
                let result="";
                if (val && this.inquirystatuslist) {

                   for (let res of this.inquirystatuslist) {
                       if (parseInt(val) === parseInt(res.value) || parseInt(val.inquiryStatus) === parseInt(res.value)) {
                           result = res.title;
                           break;
                       }

                   }
                }
                return(result);
            },

            createdailyReport() {


                this.hTo = this.dailyReportModel.toTime.toString().substr(11, 2);
                this.mTo = this.dailyReportModel.toTime.toString().substr(14, 2);
                this.totaltime = parseInt(this.hTo) * 60 + parseInt(this.mTo) + 1
                    - parseInt(this.hFrom) * 60 - parseInt(this.mFrom);
                this.dailyReportModel.totalWork = this.totaltime;
                this.dailyReportModel.day = this.jalaliToGregorian(this.dailyReportModel.day);
                this.dailyReportModel.fromTime = this.jalaliToGregorian(this.dailyReportModel.fromTime);
                this.dailyReportModel.toTime = this.jalaliToGregorian(this.dailyReportModel.toTime);
                this.dailyReportModel.titleWorkId = 4;
                if(this.dailyReportMode==="create") {
                    this.dailyReportModel.description = "ثبت دلایل باخت استعلام - " + this.inquiriModel.customerFullName;
                }
                else {
                    this.dailyReportModel.description = "ویرایش دلایل باخت استعلام - " + this.inquiriModel.customerFullName ;
                }

                let rec = 0;
                for (let pr of this.productPriceInquiry) {
                    rec++;
                    this.dailyReportModel.description = this.dailyReportModel.description + "  - "+ pr.productName + " - " + pr.productCount;
                    if (rec > 3) break;
                }

                new BaseService("dailyReports", "/CreatedailyReports").create(this.dailyReportModel).then(response => {
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });

            },

            updateInquiryRecordDate() {

                for(let stat of this.inquirystatuslist)
                {
                    if(this.selectedinquiristatus===stat.title)
                    {
                        this.inquiriModel.inquiryStatus=stat.value;
                        break;
                    }
                }


                new BaseService("Inquiry", "/UpdateInquirys").update(this.inquiriModel).then(response => {
                    this.$noty.success("قیمت های استعلام با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.isSending = false;
                    this.showArchive = false;
                    this.getInquirisList();

                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });


            },

            onCreateSendInvoiceDatePicked(val) {

                this.sendInvoicedate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.sendInvoiceModel.sendInvoicedate = this.jalaliToGregorian(val);
            },
            toggleCreateSendInvoiceDatePicker() {
                this.$refs.sendInvoicedate.togglePicker();
            },

            onCreateSendProductsDatePicked(val) {

                this.sendProductsDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.sendProductsModel.sendProductsdate = this.jalaliToGregorian(val);
            },
            toggleCreateSendProductsDatePicker() {
                this.$refs.sendProductsdate.togglePicker();
            },
            onCreateRegisterInTejaratDatePicked(val) {
                this.registerInTejaratDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.registerInTejaratModel.registerInTejaratdate = this.jalaliToGregorian(val);
            },
            toggleRegisterInTejaratDatePicker() {
                this.$refs.registerInTejaratDate.togglePicker();
            },

            onCreateReceiveInvoiceDatePicked(val) {
                this.receiveInvoiceDate = Moment(val, 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                this.receiveInvoiceModel.receiveInvoiceDatedate = this.jalaliToGregorian(val);
            },
            toggleReceiveInvoiceDatePicker() {
                this.$refs.registerInTejaratDate.togglePicker();
            },

            onChangeRank() {
                if(this.inquiriModel.rank!==1)
                {
                    this.selectedinquiristatus="بازنده";
                    this.inquiriModel.inquiryStatus=6;

                }
                else
                {
                    this.selectedinquiristatus="برنده شده";
                    this.inquiriModel.inquiryStatus=5;

                }


            },
            onChangeWinnerAmount(){
                let a=0;
                a=this.inquiriModel.winnerAmount;

                this.winnerAmountShow = (a * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            },
            CheckTime(val) {
                this.timecheck = val*1;
                if (parseInt(this.timecheck) > this.maxtime) {
                    this.timecheck = this.maxtime;
                }
                return (this.timecheck);
            },
            getenSample() {
                new BaseService("enum", "/GetEnHaveNoHave").getList().then(response => {
                    this.ensamples = response.data;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getEnInvoiceType() {
                new BaseService("enum", "/GetEnInvoiceType").getList().then(response => {
                    this.eninvoiceType = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getEnInquiriType() {
                new BaseService("enum", "/GetEnInquiriType").getList().then(response => {
                    this.eninquiritype = response.data;

                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },

            getEnShippingSendInvoice() {
                new BaseService("enum", "/GetEnShippingMethod").getList().then(response => {
                    for(let list of response.data) {
                        if (parseInt(list.value) > 10 && parseInt(list.value) < 20 ) {
                            this.enShippingSendInvoice.push({
                                title: list.title,
                                value: list.value,
                            });
                        }
                    }


                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getEnShippingSendProduct() {
                new BaseService("enum", "/GetEnShippingMethod").getList().then(response => {
                    for(let list of response.data) {
                        if (parseInt(list.value) > 20 && parseInt(list.value) < 30 ) {
                            this.enShippingSendProduct.push({
                                title: list.title,
                                value: list.value,
                            });
                        }
                    }


                }).catch(error => {

                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            getunits() {
                new BaseService("unit", "/Getunit").getList().then(response => {
                    this.units = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            showDateDayWork(val) {
                if (val) {
                    return (this.gregorianToJalaliBeautified(val, false));
                }
            },
            showExpiryHour(val){
                if (val) {
                    if (val.toString().length === 4) {
                        return (val.toString().substr(0, 2) + ":" + val.toString().substr(3, 2));
                    } else if (val.toString().length === 3) {
                        return (val.toString().substr(0, 2) + ":" + val.toString().substr(2, 1)+"0");

                    } else if (val.toString().length === 2) {
                        return (val.toString().substr(0, 2) + ":00");
                    }
                    else if (val.toString().length === 1) {
                        return ("0"+val.toString().substr(0, 1) + ":00");
                    }
                }
            },
            showRank(val) {

                let str="";

                if (val.rank === 0 || val.rank == null) {
                    str='رتبه مشخص نشده';
                }
                if (val.rank === 1) {
                    str='نفر اول';
                }
                if (val.rank === 2) {
                    str='نفر دوم';
                }
                if (val.rank === 3) {
                    str='نفر سوم';
                }
                if (val.rank === 4) {
                    str='نفر چهارم';
                }
                if (val.rank === 5) {
                    str='نفر پنجم';
                }
                if (val.rank === 6) {
                    str='نفر ششم';
                }
                if (val.rank === 7) {
                    str='نفر هفتم';
                }
                if (val.rank === 8) {
                    str='نفر هشتم';
                }
                if (val.rank === 9) {
                    str='نفر نهم';
                }
                if (val.rank >= 10) {
                    str='نفر دهم';
                }
                return( str);
            },
            showRank_Rate(val) {

                let str="";

                if (val.rank === 0 || val.rank == null) {
                    str='رتبه مشخص نشده';
                }
                if (val.rank === 1) {
                    str='نفر اول';
                }
                if (val.rank === 2) {
                    str='نفر دوم';
                }
                if (val.rank === 3) {
                    str='نفر سوم';
                }
                if (val.rank === 4) {
                    str='نفر چهارم';
                }
                if (val.rank === 5) {
                    str='نفر پنجم';
                }
                if (val.rank === 6) {
                    str='نفر ششم';
                }
                if (val.rank === 7) {
                    str='نفر هفتم';
                }
                if (val.rank === 8) {
                    str='نفر هشتم';
                }
                if (val.rank === 9) {
                    str='نفر نهم';
                }
                if (val.rank >= 10) {
                    str='نفر دهم';
                }
                return(val.rank +" - "+ str);
            },
            showShippingMethod(val){

                for(let ship of this.enShippingMethod)
                {
                    if(val.shippingMethod ===ship.value)
                    {
                        val.shippingMethodView=ship.title;
                    }
                }

            },
            showInvoiceType(val){


                for(let inv of this.eninvoiceType)
                {
                    if(val.invoiceType ===inv.value)
                    {
                        val.invoiceTypeView=inv.title;
                    }
                }
            },
            onCausesChange(val){

                if(val && val.id) {
                    this.filtercauses = val;
                    this.inquiricausesModel.causesId = val.id;
                }
            },
            onInquiriStatusChange(val){
                this.selectedinquiristatus = val;
                this.inquiriModel.inquiryStatus = val.value;
                if(val.value===5)
                {
                    this.inquiriModel.rank=1;

                }


            },
            editInquiriCausesItem(item){
                this.inquiricausesMode="edit";
                this.filtercauses =item.reason;
                this.inquiricausesModel.id=item.id;
                this.inquiricausesModel.percentage=item.percentage;
                this.inquiricausesModel.description=item.description;
                this.inquiricausesModel.causesId=item.causesId;
                this.filtercauses =item.reason;
                this.inquiricausesModel.causesId=item.causesId;
            },




            cancelInquiryFollowUp(){
                 this.showinquiry=false;
                 this.showsendInvoice=false;
                 this.$refs.insertModal.hideModal();
            },




            getInquirisList() {
                var status=5;
                new BaseService("Inquiry", `/GetInquirysByStatus/${status}`).getList().then(response => {
                    this.inquirisList = response.data;
                    this.setInquiryStatusName();

                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                });

            },

            onArchiveClicked(){
                if (this.showArchive) {
                    this.showArchive = false;
                    this.getInquirisList();
                } else {
                    this.showArchive = true;
                    var status = 5;
                    new BaseService("Inquiry", `/GetArchivedInquirys/${status}`).getList().then(response => {
                        this.inquirisList = response.data;
                        this.setInquiryStatusName();

                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.$refs.insertModal.hideModal();
                    });
                }
            },
            recordInquiriItem(item) {
                this.showinquiry=true;
                this.showsendInvoice =false;
                this.dailyReportModel = {
                    id: 0,
                    description: "",
                    day: "",
                    fromTime: "",
                    toTime: "",
                    totalWork: "",
                    titleWorkId: "",
                    bossId: "",
                    bossApprovalDate: "",
                    managerId: "",
                    managerApprovalDate: "",
                    companyId: 0,
                    managerDescription :"",
                    bossDescription :"",
                    managerConfirm:0,
                    bossConfirm:0,
                };
                this.dailyReportMode="create";
                this.dateObj = new Date().toJSON();
                this.currentDate = this.gregorianToJalali(this.dateObj, false);
                this.dailyReportModel.day= Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.dailyReportModel.fromTime = Moment(this.currentDate).format('YYYY/MM/DD HH:mm');
                this.hFrom = this.dailyReportModel.fromTime.toString().substr(11,2);
                this.mFrom =  this.dailyReportModel.fromTime.toString().substr(14,2);


                this.inquiriModel = item;
                this.inquiryId = item.id;
                if (this.showArchive) {
                    this.inquiriPriceMode = "edit";
                }
                else {
                    this.inquiriPriceMode = "create";
                }
                for (let it of this.eninquiritype) {
                    if (it.value === item.inquiriType) {
                        this.selectedinquiritype = it.title;
                    }
                }


                if (item.registrationDate != null) {
                    this.inquirydate = Moment(this.gregorianToJalali(item.registrationDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.startDate != null) {
                    this.inquiryStartdate = Moment(this.gregorianToJalali(item.startDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.expiryDate != null) {
                    this.inquiryEnddate = Moment(this.gregorianToJalali(item.expiryDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                if (item.recordDate != null && item.recordDate.toString()!=="0001-01-01T00:00:00") {
                    this.recordDate = Moment(this.gregorianToJalali(item.recordDate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                }
                for (let it of this.inquirystatuslistWinLost) {
                    if (it.value === item.inquiryStatus) {
                        this.selectedinquiristatus = it.title;
                        this.inquiriModel.inquiryStatusName=it.title;
                    }
                }

                this.inquiricausesModel = {
                    id: 0,
                    inquiryId: 0,
                    causesId: 0,
                    percentage: "",
                    description: "",
                };
                this.inquiricausesModel.inquiryId=this.inquiryId;
                this.onChangeWinnerAmount();

                this.getSupplierInquiryLists(item);




            },
            getSupplierInquiryLists(item) {

                if (item.id) {

                    new BaseService("ProductInquirySuggest", `/GetProductInquiry/${item.id}`).getList().then(response => {
                        if (response.data.length > 0) {

                            this.supplierinquiry2 = response.data;

                            this.supplierinquiry = [{
                                actionerId: 0,
                                customerCode: '',
                                customerFullName: '',
                                customerId: '',
                                id: '',
                                inquiryId: '',
                                invoiceType: '',
                                invoiceTypeView: '',
                                maximumValidityDate: '',
                                mobile: '',
                                nationalCode: '',
                                otherExplanations: '',
                                proformaInvoiceStatus: '',
                                rank: '',
                                rankView: '',
                                row: '',
                                sampleProduct: '',
                                sampleShipmentCode: '',
                                settlementPeriodWithSupplier: '',
                                shippingMethod: '',
                                shippingMethodView: '',
                                status: '',
                                supplierInquiryDate: '',
                                supplierInquiryHour: '',
                                supplierInquiryId: '',
                                taxCode: '',
                                totalPrice: '',
                                userId: '',
                                userName: '',
                            }];
                            this.productPriceInquiry= [{
                                id: "",
                                supplierInquiryId: "",
                                inquiryId: "",
                                needSample: "",
                                productId: "",
                                productName: "",
                                productCode: "",
                                unitId: "",
                                unitName: "",
                                productCount: "",
                                descriptionOnSite: "",
                                row: 0,
                                buyPrice: 0,
                                buyTotalPrice: 0,
                                buyDiscount: 0,
                                buyTotalNetPrice: 0,
                                buyVat: 0,
                                buyTotalVat: 0,
                                buyTotalPriceVat: 0,
                                buyVatshow: "",
                                buyPriceshow: "",
                                buyTotalPriceshow: "",
                                buyDiscountshow: "",
                                buyTotalNetPriceshow: "",
                                buyTotalVatshow: "",
                                buyTotalPriceVatshow: "",

                                percentageIncrease:"",
                                percentageIncreaseShow:"",
                                sellPrice: 0,
                                sellTotalPrice: 0,
                                sellDiscount: 0,
                                sellTotalNetPrice: 0,
                                sellVat: 0,
                                sellTotalVat: 0,
                                sellTotalPriceVat: 0,
                                sellVatshow: "",
                                sellPriceshow: "",
                                sellTotalPriceshow: "",
                                sellDiscountshow: "",
                                sellTotalNetPriceshow: "",
                                sellTotalVatshow: "",
                                sellTotalPriceVatshow: "",
                            }];
                            let chknew=true;

                            for (let supin of this.supplierinquiry2) {

                                this.showRank(supin);

                                this.showShippingMethod(supin);
                                this.showInvoiceType(supin);
                                if(chknew) {

                                    this.supplierinquiry.push({
                                        actionerId: supin.actionerId,
                                        customerCode: supin.customerCode,
                                        customerFullName: supin.customerFullName,
                                        customerId: supin.customerId,
                                        id: supin.id,
                                        inquiryId: supin.inquiryId,
                                        invoiceType: supin.invoiceType,
                                        invoiceTypeView: supin.invoiceTypeView,
                                        maximumValidityDate: supin.maximumValidityDate,
                                        mobile: supin.mobile,
                                        nationalCode: supin.nationalCode,
                                        otherExplanations: supin.otherExplanations,
                                        proformaInvoiceStatus: supin.proformaInvoiceStatus,
                                        rank: supin.rank,
                                        rankView: supin.rankView,
                                        row: supin.row,
                                        sampleProduct: supin.sampleProduct,
                                        sampleShipmentCode: supin.sampleShipmentCode,
                                        settlementPeriodWithSupplier: supin.settlementPeriodWithSupplier,
                                        shippingMethod: supin.shippingMethod,
                                        shippingMethodView: supin.shippingMethodView,
                                        status: supin.status,
                                        supplierInquiryDate: supin.supplierInquiryDate,
                                        supplierInquiryHour: supin.supplierInquiryHour,
                                        supplierInquiryId: supin.supplierInquiryId,
                                        taxCode: supin.taxCode,
                                        totalPrice: supin.totalPrice,
                                        userId: supin.userId,
                                        userName: supin.username,
                                    });
                                    chknew = false;
                                }
                                this.productPriceInquiry.push({
                                    id: supin.id,
                                    inquiryId: supin.inquiryId,
                                    supplierInquiryId:supin.supplierInquiryId,
                                    needSample: "",
                                    productId: supin.productId,
                                    productName: supin.productName,
                                    productCode: supin.productCode,
                                    unitId: supin.unitId,
                                    unitName: supin.unitName,
                                    productCount: supin.productCount,
                                    descriptionOnSite: "",
                                    row: supin.row,
                                    buyPrice: supin.buyPrice,
                                    buyTotalPrice: supin.buyTotalPrice,
                                    buyDiscount: 0,
                                    buyTotalNetPrice: supin.buyTotalNetPrice,
                                    buyVat: 0,
                                    buyTotalVat: 0,
                                    buyTotalPriceVat: 0,
                                    buyVatshow: "",
                                    buyPriceshow: "",
                                    buyTotalPriceshow: "",
                                    buyDiscountshow: "",
                                    buyTotalNetPriceshow: "",
                                    buyTotalVatshow: "",
                                    buyTotalPriceVatshow: "",

                                    percentageIncrease: supin.percentageIncrease,
                                    sellPrice: supin.sellPrice,
                                    sellTotalPrice: supin.sellTotalPrice,
                                    sellDiscount: supin.sellDiscount,
                                    sellTotalNetPrice: supin.sellTotalNetPrice,
                                    sellVat: supin.sellVat,
                                    sellTotalVat: supin.sellTotalVat,
                                    sellTotalPriceVat: supin.sellTotalPriceVat,
                                    sellVatshow: "",
                                    sellPriceshow: "",
                                    sellTotalPriceshow: "",
                                    sellDiscountshow: "",
                                    sellTotalNetPriceshow: "",
                                    sellTotalVatshow: "",
                                    sellTotalPriceVatshow: "",
                                });
                                this.calcSumAmounts();

                            }
                            this.isLoading = true;
                            this.$refs.insertModal.showModal();
                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });

                }

            },

            showDataOnTable(item){
        //        this.getSupplierInquiryProducts(item);

            },

            cancelSendInvoice() {

                this.isSending = false;
                this.showinquiry=true;
                this.showsendInvoice=false;
                this.$refs.insertModal.showModal();
            },
            createSendInvoice(){

            },
            updateSendInvoice(){

            },
            cancelSendProducts() {
                this.showinquiry=true;
                this.isSending = false;

                this.showsendInvoice=false;
                this.showsendProducts=false;
                this.$refs.insertModal.showModal();
            },
            createSendProducts(){

            },
            updateSendProducts(){

            },
            cancelRegisterInTejarat() {
                this.showinquiry=true;
                this.isSending = false;
                this.showsendInvoice=false;
                this.showsendProducts=false;
                this.showRegisterInTejarat=false;
                this.$refs.insertModal.showModal();
            },
            createRegisterInTejarat(){

            },
            updateReceiveInvoice(){

            },
            cancelReceiveInvoice() {
                this.showinquiry=true;
                this.isSending = false;
                this.showsendInvoice=false;
                this.showsendProducts=false;
                this.showRegisterInTejarat=false;
                this.showReceiveInvoice=false;
                this.$refs.insertModal.showModal();
            },
            createReceiveInvoice(){

            },
            updateRegisterInTejarat(){

            },
            searching() {
                if (this.search.length >= 2) {
                    this.isLoading = false;
                    new BaseService("Inquiry", `/SearchInquirys/${this.search}`).getList().then(response => {
                        if (response.data.length > 0) {
                            this.inquirisList = response.data;
                            this.isLoading = true;
                        }
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            }
            ,

            calcSellPriceWithPercentage(a) {

                if (a) {
                    let amount = 0;
                    amount = a.buyPrice;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        a.buyPrice = a.buyPrice * 1;
                        a.productCount = a.productCount * 1;
                        a.percentageIncrease =a.percentageIncrease *1;
                        amount = a.percentageIncrease;
                        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                            a.sellPrice = a.buyPrice +  a.buyPrice *  a.percentageIncrease / 100;
                            a.sellTotalPrice = a.sellPrice * a.productCount;
                            a.sellDiscount = 0;
                            a.sellTotalNetPrice = a.sellTotalPrice;
                            amount = a.sellVat;
                            if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                                if (parseInt(amount) > parseInt(this.maxvat)) {
                                    a.sellVat = this.maxvat;
                                }
                                a.sellVat = a.sellVat * 1;
                                a.sellVatshow = a.sellVat / 100;
                                a.sellTotalVat = a.sellTotalPrice * a.sellVat / 100;
                                a.sellTotalPriceVat = a.sellTotalNetPrice + a.sellTotalVat;
                            }
                        }
                    }
                    a.percentageIncreaseShow = (a.percentageIncrease /100).toString() ;
                    a.sellPriceshow = (a.sellPrice * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalPriceshow = (a.sellTotalPrice * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellDiscountshow = "0";
                    a.sellTotalNetPriceshow = (a.sellTotalNetPrice * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalVatshow = (a.sellTotalVat * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalPriceVatshow = (a.sellTotalPriceVat * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    this.calcSumAmounts();


                }
            },
            calcSellPriceWithSellPrice(a) {
                if (a) {
                    let amount = 0;
                    amount = a.buyPrice;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        a.buyPrice = a.buyPrice * 1;
                        a.productCount = a.productCount * 1;
                        amount = a.sellPrice;
                        a.sellPrice = a.sellPrice * 1;
                        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                            a.percentageIncrease  = (( a.sellPrice - a.buyPrice )/ a.buyPrice *  100).toFixed(2);
                            a.sellTotalPrice = a.sellPrice * a.productCount;
                            a.sellDiscount = 0;
                            a.sellTotalNetPrice = a.sellTotalPrice;
                            amount = a.sellVat;
                            if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                                if (parseInt(amount) > parseInt(this.maxvat)) {
                                    a.sellVat = this.maxvat;
                                }
                                a.sellVat = a.sellVat * 1;
                                a.sellVatshow = a.sellVat / 100;
                                a.sellTotalVat = a.sellTotalPrice * a.sellVat / 100;
                                a.sellTotalPriceVat = a.sellTotalNetPrice + a.sellTotalVat;
                            }
                        }
                    }
                    a.percentageIncreaseShow = (a.percentageIncrease /100).toFixed(2) ;
                    a.sellPriceshow = (a.sellPrice * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalPriceshow = (a.sellTotalPrice * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellDiscountshow = "0";
                    a.sellTotalNetPriceshow = (a.sellTotalNetPrice * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalVatshow = (a.sellTotalVat * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalPriceVatshow = (a.sellTotalPriceVat * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    this.calcSumAmounts();
                    return;

                }
            },
            calcVatSellPrice(a){
                if (a) {
                    let amount = 0;
                    amount = a.sellVat;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        if (parseInt(amount) > parseInt(this.maxvat)) {
                            a.sellVat = this.maxvat;
                        }
                        a.sellVat = a.sellVat * 1;
                        a.sellVatshow = a.sellVat / 100;
                        a.sellTotalVat = a.sellTotalPrice * a.sellVat / 100;
                        a.sellTotalPriceVat = a.sellTotalNetPrice + a.sellTotalVat;
                    }
                    a.sellTotalVatshow = (a.sellTotalVat * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    a.sellTotalPriceVatshow = (a.sellTotalPriceVat * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    this.calcSumAmounts();
                    return;

                }
            },
            thousandSeprator(a) {

                if (a) {
                    let amount = 0;

                    // amount = a.buyPrice;
                    // if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    //     a.buyPrice = a.buyPrice * 1;
                    //     a.buyPriceshow = (amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    //     a.buyTotalNetPrice = a.buyPrice * a.productCount;
                    // }
                    // a.buyTotalNetPriceshow = a.buyTotalNetPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    amount = a.discount;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        if (a.discount > 0) {
                            a.discount = a.discount * 1;
                            a.discountshow = (amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                        a.totalNetPrice = a.totalPrice - a.discount;
                    }
                    a.totalNetPriceshow = a.totalNetPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    amount = a.vat;
                    if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                        if (parseInt(amount) > parseInt(this.maxvat)) {
                            a.vat = this.maxvat;
                        }
                        a.vat = a.vat * 1;
                        a.vatshow = a.vat / 100;
                        a.totalVat = a.totalNetPrice * a.vat / 100;
                        if (parseInt(a.vat) > 0 && (parseInt(this.supplierInquiryList.invoiceType) == 0 || this.supplierInquiryList.invoiceType == "")) {
                            Utils.handleErrorWithNotification("فاکتور غیر رسمی است و یا نوع فاکتورانتخاب نشده است.لطفا پس از تغییر نوع فاکتور از غیر رسمی به فاکتور رسمی امتحان کنید", this.$noty);
                            a.vat = 0;
                            a.vatshow = "0";
                            a.totalVat = 0;
                            a.totalVatshow = "0";
                        }
                        if (parseInt(a.vat) > 0 && a.buyPrice == 0) {
                            Utils.handleErrorWithNotification("قیمت خرید وارد نشده است . لطفا ابتدا قیمت خرید را وارد نمایید و دوباره امتحان کنید", this.$noty);
                            a.vat = 0;
                            a.vatshow = "0";
                            a.totalVat = 0;
                            a.totalVatshow = "0";
                        }

                    }
                    a.totalVatshow = a.totalVat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                    a.totalPriceVat = a.totalNetPrice + a.totalVat / 100;
                    a.totalPriceVatshow = a.totalPriceVat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    this.calcSumAmounts();
                    return;
                }
            },
            calcSumAmounts() {
                this.tproductcount=0;
                this.tbuyPrice=0;
                this.tbuyTotalNetPrice=0;
                this.tsellPrice=0;
                this.tsellTotalPrice=0;
                this.tsellDiscount=0;
                this.tsellTotalNetPrice=0;
                this.tsellVat=0;
                this.tsellTotalVat=0;
                this.tsellTotalPriceVat=0;
                for (let pr of this.productPriceInquiry) {

                    if (pr.productId >= 0) {
                        this.tproductcount = this.tproductcount +pr.productCount*1;
                        this.tbuyprice = this.tbuyprice + pr.buyPrice;
                        this.tbuyTotalNetPrice=this.tbuyTotalNetPrice +pr.buyTotalNetPrice;
                        this.tsellPrice=this.tsellPrice +pr.sellPrice;
                        this.tsellTotalPrice=this.tsellTotalPrice+pr.sellTotalPrice;
                        this.tsellDiscount=this.tsellDiscount+pr.sellDiscount;
                        this.tsellTotalNetPrice=this.tsellTotalNetPrice+pr.sellTotalNetPrice;
                        this.tsellTotalVat=this.tsellTotalVat+pr.sellTotalVat;
                        this.tsellTotalPriceVat=this.tsellTotalPriceVat+pr.sellTotalPriceVat;
                    }
                }
                if(this.tsellTotalVat>0) {
                    this.tsellVat = (this.tsellTotalVat / this.tsellTotalNetPrice  ).toFixed(3);
                }
                this.tpercentageIncrease = ((this.tsellTotalPrice - this.tbuyTotalNetPrice) / this.tbuyTotalNetPrice).toFixed(3);

                this.inquiriModel.suggestedPrices = this.tsellTotalPrice + this.inquiriModel.shippingCostEstimate;
                let totPrice =0;
                let shipping =0;
                totPrice = this.tsellTotalPrice;
                shipping =this.inquiriModel.shippingCostEstimate;
                if(totPrice === '' || totPrice == undefined || totPrice == null)
                {
                    totPrice=0;
                }
                if(shipping === '' || shipping == undefined ||  shipping == null) {
                    shipping = 0;
                }
                totPrice=parseInt(totPrice);
                shipping=parseInt(shipping);
                let totalamount=0;
                totalamount=totPrice*1+shipping*1;

                this.inquiriModel.suggestedPrices = totalamount;
                this.inquiriModel.shippingCostEstimate=shipping;
                this.tsellTotalPriceshow =totPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.shippingCostEstimateshow = shipping.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.totalSuggestAmontshow = totalamount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            },
            onChangeShippingCostEstimate() {

                let totPrice = 0;
                let shipping = 0;
                totPrice = this.tsellTotalPrice;
                shipping = this.inquiriModel.shippingCostEstimate
                if (totPrice === '' || totPrice == undefined || totPrice == null) {
                    totPrice = 0;
                }
                if (shipping === '' || shipping == undefined || shipping == null) {
                    shipping = 0;
                }
                totPrice=parseInt(totPrice);
                shipping=parseInt(shipping);
                let totalamount = 0;
                totalamount = totPrice + shipping;
                this.inquiriModel.suggestedPrices = totalamount;
                this.inquiriModel.shippingCostEstimate=shipping;
                this.shippingCostEstimateshow = shipping.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                this.totalSuggestAmontshow = totalamount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            onfilterShippingSendInvoiceChange(val) {
                if (val && val.title != null) {
                    this.filterShippingSendInvoice = val.title;
                    this.sendInvoiceModel.shippingSendInvoice = val.value;

                }
            },
            onfilterShippingSendProductChange(val) {
                if (val && val.title != null) {
                    this.filterShippingSendProduct = val.title;
                    this.sendProductsModel.shippingSendProducts = val.value;

                }
            },
            onfilterRegisterInTejaratStatusChange(val) {
                if (val && val.title != null) {
                    this.filterRegisterInTejaratStatus = val.title;
                    this.registerInTejaratModel.registerInTejaratStatus = val.value;

                }
            },
            onfilterReceiveInvoiceStatusChange(val) {
                if (val && val.title != null) {
                    this.filterReceiveInvoice = val.title;
                    this.receiveInvoiceModel.receiveInvoiceStatus = val.value;

                }
            },
            onfilterdeliveryToCustomerChange(val){
                if (val && val.title != null) {
                    this.filterdeliveryToCustomer = val.title;
                    this.sendInvoiceModel.deliveryToCustomer = val.value;

                }
            },
            onfilterdeliveryProductsToCustomerChange(val){
                if (val && val.title != null) {
                    this.filterdeliveryProductToCustomer = val.title;
                    this.sendProductsModel.deliveryProductToCustomer = val.value;

                }
            },
            onfilterdeliveryToFinanceChange(val){
                if (val && val.title != null) {
                    this.filterdeliveryToFinance = val.title;
                    this.sendInvoiceModel.deliveryToFinance = val.value;

                }
            },
            onfilterInvoiceDeliveryStatusChange(val){
                if (val && val.title != null) {
                    this.filterInvoiceDeliveryStatus = val.title;
                    this.sendInvoiceModel.InvoiceDeliveryStatus = val.value;

                }
            },
            onfilterProductsDeliveryStatusChange(val){
                if (val && val.title != null) {
                    this.filterProductsDeliveryStatus = val.title;
                    this.sendProductsModel.productsDeliveryStatus = val.value;

                }
            },






        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>